<template>
    <div>
        <Navbar />
        <!-- Start Main Banner Area -->
        <div class="main-banner-area">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="d-table">
                            <div class="d-table-cell">
                                <div class="main-banner-content">
                                    <span>Rhema Prophetic Centre</span>
                                    <h3>
                                        Helping believers become effective ministers of the gospel
                                        of Jesus Christ
                                    </h3>

                                    <div class="banner-btn">
                                        <router-link
                                                class="optional-btn"
                                                :to="{
                        name: 'Register',
                        params: {
                          src
                        }
                      }"
                                        >Become Member
                                            <i class="flaticon-right"></i>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12">
                        <div class="banner-slider-wrap">
                            <div class="banner-image-slider owl-carousel owl-theme">
                                <div class="image-item">
                                    <img
                                            class="image"
                                            src="assets/img/rpc/rpc5.JPG"
                                            alt="image"
                                    />
                                </div>

                                <div class="image-item">
                                    <img
                                            class="image"
                                            src="assets/img/rpc/rpc2.JPG"
                                            alt="image"
                                    />
                                </div>

                                <div class="image-item">
                                    <img
                                            class="image"
                                            src="assets/img/rpc/rpc4.JPG"
                                            alt="image"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="banner-shape">
                <img src="assets/img/home-two/shape.png" alt="image" />
            </div>
        </div>
        <!-- End Main Banner Area -->

        <!-- Start Feature Area -->
        <section class="features-section ptb-100">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="feature-content">
                            <span>Services</span>
                            <h3>Raising ministers of the gospel</h3>
                            <p>
                                Helping the church rediscover and practice personal relationship
                                with God through effective prayer, bible study and fellowship
                                with Holy Spirit
                            </p>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="feature-slider owl-carousel owl-theme">
                            <div class="feature-card mx-4">
                                <div class="icon">
                                    <img src="assets/img/icon/1.png" alt="image" />
                                    <img src="assets/img/icon/white-1.png" alt="image" />
                                </div>

                                <h3>Who we are</h3>
                                <p>
                                    The rhema prophetic centre is a non-denominational Christian
                                    centre. The main objective of this group is to provide a
                                    platform for the demonstration of the person, plans and
                                    purposes of God for the Church.
                                </p>
                            </div>

                            <div class="feature-card mx-4">
                                <div class="icon">
                                    <img src="assets/img/icon/2.png" alt="image" />
                                    <img src="assets/img/icon/white-2.png" alt="image" />
                                </div>

                                <h3>Our Mission</h3>
                                <p>
                                    &#8594; To provide a platform for effective communication and
                                    demonstration of the person, plans and purposes of God for the
                                    church in simplicity and power.
                                </p>
                            </div>

                            <div class="feature-card mx-4">
                                <div class="icon">
                                    <img src="assets/img/icon/3.png" alt="image" />
                                    <img src="assets/img/icon/white-3.png" alt="image" />
                                </div>

                                <h3>Our Vision</h3>
                                <p>
                                    We see every believer BECOME a minister of the gospel of Jesus
                                    Christ through effective discipleship
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Feature Area -->

        <!-- Start About Area -->
        <section class="about-area">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-6 p-0">
                        <div class="about-image ptb-100">
                            <img src="assets/img/rpc/rpc5.JPG" alt="image" />
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="about-item about-item-two ptb-100">
              <span>
                <i class="flaticon-care-about-plants"></i>
                About us
              </span>
                            <h3 class="ml-4">Objectives</h3>
                            <ul>
                                <li>
                                    <p>To communicate the word of God in simplicity and power</p>
                                </li>
                                <li>
                                    <p>
                                        To train the church of Jesus Christ on effective prayers
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        To help the church to rediscover and practice personal
                                        relationship with the Holy Spirit through fellowship
                                    </p>
                                </li>

                                <h3>OUTPUTS</h3>
                                <li><p>Weekly Tuesday and Friday Prayer Meeting</p></li>
                                <li><p>Documented over 2000 Healings and Miracles</p></li>
                                <li>
                                    <p>
                                        Production of Spiritual Testimony booklet to encourage sick
                                        and oppressed
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Spiritual Revival and Meditation at the Livingstone Memorial
                                        Kolebeng
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Organized Discipleship training for members and Local
                                        ministers of the gospel in Botswana in November, 2019.
                                        Training was run by London-based Missionary Organization
                                    </p>
                                </li>
                            </ul>

                            <div class="about-btn">
                                <router-link
                                        class="default-btn"
                                        :to="{
                    name: 'Register',
                    params: {
                      src
                    }
                  }"
                                >Join
                                    <i class="flaticon-right"></i>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End About Area -->

        <section class="testimonials-section pb-100">
            <div class="container">
                <div class="section-title">
          <span>
            <i class="flaticon-testimonial"></i>
            Services and Outputs
          </span>
                    <h2>Our Programs and Outputs</h2>
                </div>

                <div class="row border-hide">
                    <div class="testimonials-slider-two owl-carousel owl-theme">
                        <div class="testimonials-area-content">
                            <h3>Our Services</h3>
                            <ul>
                                <li>
                                    Non-denominational Weekly Prayer Meeting;
                                </li>
                                <li>
                                    Non-denominational weekly Bible study meetings;
                                </li>
                                <li>
                                    24 Hours Prayer Centre
                                </li>
                                <li>
                                    National Worship Arena
                                </li>
                            </ul>
                        </div>

                        <div class="testimonials-area-content">
                            <h3>Outputs</h3>
                            <ul>
                                <li>
                                    Weekly Tuesday and Friday Prayer Meeting
                                </li>
                                <li>
                                    Documented over 2000 Healings and Miracles
                                </li>
                                <li>
                                    Production of Spiritual Testimony booklet to encourage sick
                                    and oppressed
                                </li>
                                <li>
                                    Spiritual Revival and Meditation at the Livingstone Memorial
                                </li>
                            </ul>
                        </div>
                        <div class="testimonials-area-content">
                            <h3>Looking Forward</h3>
                            <ul>
                                <li>
                                    Continued Weekly Tuesday and Friday Prayer Meeting
                                </li>
                                <li>
                                    Development of a non-denominational Prayer and Meditation
                                    Centre open to all
                                </li>
                                <li>
                                    Development of non-denominational Worship Centre in Botswana
                                </li>
                                <li>
                                    Continued Discipleship training for members and Local
                                    ministers of the gospel in Botswana. Training will be run by
                                    foreign Missionary Organization
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <Footer />
    </div>
</template>

<script>
    import Navbar from "./Navbar";
    import Footer from "../../Footer";
    export default {
        components: {
            Navbar,
            Footer
        },
        data() {
            return {
                src:
                    "https://docs.google.com/forms/d/e/1FAIpQLSdM6HhRloSIC-esVhVN7sQTJ1TpRbidrJdqOXg-GhwB1Jpo6A/viewform"
            };
        },
        mounted() {
            window.jQuery('.feature-slider').owlCarousel({
                loop: true,
                nav: false,
                dots: true,
                autoplayHoverPause: true,
                autoplay: true,
                smartSpeed: 1000,
                margin: 30,
                items: 1
            });
        }
    };
</script>

<style scoped>
    .team-img {
        height: 300px;
    }
</style>
